import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { SubmissionError, initialize, change, untouch} from 'redux-form'
import { saveDeposit, getNextStep, submitForm, stopSubmitForm } from '../actions/users';
import { getErrorsApiToReduxForm } from '../utils/utils.js';
import DepositForm from '../components/DepositForm.js';

const mapStateToProps = (state) => {

    return {
        isLoading: state.users.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setDefaultValue(values) {
            dispatch(initialize('DepositForm', values, null));
        },
        deleteReduxFormField(fieldName){
            dispatch(change('DepositForm', fieldName, null));
            dispatch(untouch('DepositForm', fieldName));
        },
        saveDeposit(values, dispatch) {
            dispatch(submitForm())
            return dispatch(saveDeposit(values)).then((result) => {
                if (result.payload.status !== 200) {
                    dispatch(stopSubmitForm());
                    throw new SubmissionError ({...getErrorsApiToReduxForm(result.payload.response.data), _error: 'Revisá los campos indicados.'});
                } else {
                    dispatch(getNextStep()).then((result) => {
                        if (typeof(result.payload.data.endpoint) !== 'undefined') {
                            sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                            dispatch(stopSubmitForm());
                            browserHistory.push(result.payload.data.endpoint)
                        }
                    });
                }
            });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DepositForm);


/** WEBPACK FOOTER **
 ** ./src/containers/DepositFormContainer.js
 **/